export const queries = {
  allRewardsBenefits: `
  query {
    allRewardTypes(where: { isActive: true }, sortBy: [priority_ASC]) {
      id
      heading
      subHeading
      eligibility
      priority
      colorCode
      classes
      style
      hasHorizontalRow
      imageEn(where: { isActive: true }) {
        name
        file {
          publicUrl
        }
      }
      imageFr(where: { isActive: true }) {
        name
        file {
          publicUrl
        }
      }
    }
    allRewardsAndBenefits {
      rewardsFooter
      categories(where: { isActive: true }, sortBy: [priority_ASC]) {
        name
        _label_
        showCategoryLabel
        items(
          where: { isActive: true, rewardType: { isActive: true } }
          sortBy: [priority_ASC]
        ) {
          id
          name
          key
          value
          priority
          percentageValue
          classes
          style
          colSpan
          showInTablet
          rewardType {
            id
            priority
            colorCode
            classes
            style
            hasHorizontalRow
          }
        }
      }
    }
  }
`,
};
